import { useState } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import AuthLayout from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(apiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Reset password" subtitle="We'll email you a secure reset link.">
      {sent ? (
        <div className="text-center" data-testid="forgot-sent">
          <p className="text-secondary-foreground mb-6">If an account exists for that email, a reset link is on its way.</p>
          <Link to="/login"><Button variant="outline" className="rounded-full border-border">Back to login</Button></Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div className="space-y-2">
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" className="bg-secondary border-border" />
          </div>
          {error && <p className="text-sm text-destructive">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full rounded-full bg-primary text-primary-foreground font-semibold" data-testid="forgot-submit-btn">
            {loading && <Loader2 size={16} className="animate-spin" />} Send reset link
          </Button>
          <p className="text-sm text-muted-foreground text-center"><Link to="/login" className="text-primary hover:underline">Back to login</Link></p>
        </form>
      )}
    </AuthLayout>
  );
}
